(function () {
    "use strict";

    Controllers.CalendarAbstractController = class CalendarAbstractController extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor($scope, $injector, CalendarService, NavigationService, AppStates, UsersManager, SchedulingService, StatsigService) {
            super($scope, $injector);
            this.__objectType = 'CalendarAbstractController';

            this.CalendarService = CalendarService;
            this.NavigationService = NavigationService;
            this.AppStates = AppStates;
            this.UsersManager = UsersManager;
            this.SchedulingService = SchedulingService;

            this.calendarView = this.CalendarService.CALENDAR_MONTH_VIEW;
            this.hbCalendar = {
                title: '',
                date: Date.now(),
                calView: ''
            };

            this.updateCalendarView = () => {};

            this.user = this.UsersManager.getCurrUser();
            this.isSchedulingEnabled = this.SchedulingService.isSchedulingEnabled(this.user);
            this.isSchedulingPageActive = this.NavigationService.isRouteActive(this.AppStates.root_core_navigation_scheduling);
        }

        setCalendarView(view) {
            this.calendarView = view;
        }

        setCalendarActive() {
            this.isSchedulingPageActive = false;
        }

        setSchedulingActive() {
            this.isSchedulingPageActive = true;
        }

        onCalendarToolbarEvent(callback) {
            this._callback = callback;
        }
    };

}());
